import { createAction } from 'redux-actions';
import * as productPhraseTRFormTypes from './productPhraseTRFormTypes';

export const addTranslation = createAction(productPhraseTRFormTypes.ADD_TRANSLATION);
export const onSaveButtonClick = createAction(productPhraseTRFormTypes.SAVE_BUTTON_CLICK);
export const loadForm = createAction(productPhraseTRFormTypes.LOAD_FORM, data => data);
export const onDeleteButtonClick = createAction(productPhraseTRFormTypes.DELETE_BUTTON_CLICK);
